import {
  GET_ANALYTICS,
  GET_EXCLUDED_IPS,
  ADD_EXCLUDED_IP,
  DELETE_EXCLUDED_IP,
  GET_MORE_VISITS,
  VISITS_LOADING,
} from "../actions/types";

const initialState = {
  data: null,
  excludedIps: null,
  moreVisits: [], // visits loaded after the first `recentViews` page
  visitsLoading: false,
};

export default function analyticsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ANALYTICS:
      return { ...state, data: action.payload, moreVisits: [], visitsLoading: false };
    case VISITS_LOADING:
      return { ...state, visitsLoading: action.payload };
    case GET_MORE_VISITS: {
      const { range, hideBots, offset, views } = action.payload;
      const loaded = (state.data?.recentViews?.length || 0) + state.moreVisits.length;
      // Ignore stale pages (filters changed or duplicate request meanwhile)
      if (
        !state.data ||
        state.data.range !== range ||
        state.data.hideBots !== hideBots ||
        offset !== loaded
      ) {
        return { ...state, visitsLoading: false };
      }
      return {
        ...state,
        moreVisits: [...state.moreVisits, ...views],
        visitsLoading: false,
      };
    }
    case GET_EXCLUDED_IPS:
      return { ...state, excludedIps: action.payload };
    case ADD_EXCLUDED_IP:
      return state;
    case DELETE_EXCLUDED_IP:
      return state;
    default:
      return state;
  }
}
